module.exports = __webpack_public_path__ + "img/list-ol.52e8cc02.svg";